import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useMemo } from "react";
import { useResizeObserver } from "use-resize-observer";
function InnerImageThumbnail(props) {
    const src = useMemo(() => {
        if (props.originalSize || props.file.thumbnail === undefined) {
            if (typeof props.file.url === "string") {
                return props.file.url;
            }
            else {
                return URL.createObjectURL(props.file.url);
            }
        }
        else {
            return props.file.thumbnail(props.width, props.height);
        }
    }, [
        props.file,
        props.originalSize,
        props.width,
        props.height,
    ]);
    return _jsx("img", { src: src, className: "w-100 h-100 d-block object-fit-cover thumbnail-image" });
}
export default function ImageThumbnail(props) {
    const { ref, width, height } = useResizeObserver();
    return (_jsx("div", { className: "h-100 w-100", ref: ref, children: (() => {
            if (width === undefined || height === undefined) {
                return _jsx(Fragment, {});
            }
            return _jsx(InnerImageThumbnail, { file: props.file, width: width, height: height, originalSize: props.originalSize });
        })() }));
}
